import { render, staticRenderFns } from "./CardClientNew.vue?vue&type=template&id=6fecd3f0&scoped=true"
import script from "./CardClientNew.vue?vue&type=script&lang=js"
export * from "./CardClientNew.vue?vue&type=script&lang=js"
import style0 from "./CardClientNew.vue?vue&type=style&index=0&id=6fecd3f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fecd3f0",
  null
  
)

export default component.exports